
<app-header (openLoginPage)="openLoginPage($event)"></app-header>
<div  class="content">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

<app-login *ngIf="displayLoginPage"  (closeLoginPage)="openLoginPage($event)"></app-login>
